import { render, staticRenderFns } from "./SopFilterTree.vue?vue&type=template&id=5e5acec2&"
import script from "./SopFilterTree.vue?vue&type=script&lang=ts&"
export * from "./SopFilterTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports